module.exports = __webpack_public_path__ + "img/app_tip.b871085c.png";